/** Pure helpers for History result column (unit-tested). */

export function historyResultStatus(row) {
  if (row?.betType === "Call") {
    if (row?.betstatus === "Expired") return "Expired";
    if (row?.betstatus === "Cancelled") return "Cancelled";
    if (row?.betstatus === "Activated" && !row?.winStatus) return "Pending";
    if (row?.betstatus === "NotActivated" && !row?.winStatus) {
      return "Pending activation";
    }
  }
  if (!row?.winStatus) return "Pending";
  return row.winStatus;
}

export function historyResultIsNeutralAmount(row) {
  return (
    row?.betType === "Call" &&
    (row?.betstatus === "Expired" || row?.betstatus === "Cancelled")
  );
}
